module.exports = __webpack_public_path__ + "static/media/ffile.3931a727.svg";